import { useState } from "react";
import { MapPin, User, ChevronDown } from "lucide-react";
import { NavLink } from "../../ui/NavLink";
import { useAuth } from "@cabukaka/hooks";

const cities = ["Bunia", "Butembo"];

interface CitySelectorBarProps {
  selectedCity: string;
  onCityChange: (city: string) => void;
}

export const CitySelectorBar = ({ selectedCity, onCityChange }: CitySelectorBarProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const isLoggedIn = !!user;

  return (
    <div className="md:hidden relative flex items-center justify-between px-4 py-4 bg-white border-b border-gray-100 z-40">
      {/* Sélecteur de ville */}
      <div className="relative">
        <button 
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-2 text-sm font-semibold text-gray-700 hover:text-primary transition-colors py-1"
        >
          <MapPin className="w-5 h-5 text-primary" />
          <span>{selectedCity || "Choisir"}</span>
          <ChevronDown className="w-4 h-4 text-gray-400" />
        </button>

        {isOpen && (
          <div className="absolute top-full left-0 mt-3 bg-white rounded-xl shadow-xl border border-gray-100 w-40 py-2 z-50 animate-in fade-in zoom-in-95 duration-200">
            {cities.map((city) => (
              <button 
                key={city}
                onClick={() => { onCityChange(city); setIsOpen(false); }}
                className="block w-full text-left px-5 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
              >
                {city}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Bouton Inscription / Profil */}
      {isLoggedIn ? (
        <NavLink 
          to="/compte" 
          className="flex items-center gap-2 text-sm font-bold text-primary bg-primary/10 px-4 py-2 rounded-full hover:bg-primary/20 transition-all"
        >
          <User className="w-4 h-4" />
          {user.username}
        </NavLink>
      ) : (
        <NavLink 
          to="/auth/register" 
          className="text-sm font-bold text-white bg-primary px-5 py-2 rounded-full shadow-md hover:bg-primary/90 transition-all active:scale-95"
        >
          S'inscrire
        </NavLink>
      )}
    </div>
  );
};